import React from 'react';
import { Smartphone, QrCode, Bell, Shield, ArrowRight } from 'lucide-react';

const features = [
  {
    icon: Bell,
    title: 'Уведомления',
    description: 'Мгновенные уведомления о горящих турах и спецпредложениях'
  },
  {
    icon: QrCode,
    title: 'Быстрая оплата',
    description: 'Удобная и безопасная оплата через приложение'
  },
  {
    icon: Smartphone,
    title: 'Offline режим',
    description: 'Доступ к бронированию даже без интернета'
  },
  {
    icon: Shield,
    title: 'Безопасность',
    description: 'Защищенный доступ и шифрование данных'
  },
];

const MobileAppPromo: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container-custom">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700 rounded-3xl p-8 md:p-14 relative overflow-hidden">
          {/* Background decorations */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3" />
          <div className="absolute bottom-0 left-0 w-72 h-72 bg-secondary-300/10 rounded-full translate-y-1/2 -translate-x-1/3" />

          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 text-white px-4 py-1.5 rounded-full text-sm font-medium mb-6">
                Скоро
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                Мобильное приложение
                <span className="block text-secondary-300">HASAN TRAVEL</span>
              </h2>
              <p className="text-white/80 text-lg mb-10 max-w-lg">
                Бронируйте туры, отели и авиабилеты прямо с вашего смартфона. Получайте эксклюзивные предложения и следите за статусом бронирования в реальном времени.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-4 group">
                    <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-white/20 transition-colors">
                      <feature.icon className="w-6 h-6 text-secondary-300" />
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">{feature.title}</h3>
                      <p className="text-white/60 text-sm leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href="#contacts"
                className="inline-flex items-center gap-2 bg-white text-primary-500 px-8 py-4 rounded-xl font-semibold hover:bg-white/90 transition-all hover:shadow-xl group"
              >
                Узнать первым о запуске
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>

            <div className="relative hidden lg:flex items-center justify-center">
              <div className="absolute w-80 h-80 bg-secondary-300/20 rounded-full blur-3xl" />
              <div className="relative bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 shadow-2xl">
                <div className="w-64 h-[480px] bg-neutral-900 rounded-[2rem] overflow-hidden border-4 border-neutral-700 shadow-inner">
                  <div className="h-full bg-gradient-to-b from-primary-500 to-primary-700 flex flex-col items-center justify-center p-6 text-center">
                    <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4">
                      <span className="text-white font-bold text-2xl">HT</span>
                    </div>
                    <h3 className="text-white font-bold text-xl mb-2">HASAN TRAVEL</h3>
                    <p className="text-white/60 text-sm mb-6">Ваш персональный гид</p>
                    <div className="w-full space-y-3">
                      <div className="bg-white/10 rounded-xl p-3 text-left">
                        <div className="text-white/40 text-xs mb-1">Горящий тур</div>
                        <div className="text-white text-sm font-medium">Турция, Анталия</div>
                        <div className="text-secondary-300 font-bold">от 89 000 ₸</div>
                      </div>
                      <div className="bg-white/10 rounded-xl p-3 text-left">
                        <div className="text-white/40 text-xs mb-1">Новое предложение</div>
                        <div className="text-white text-sm font-medium">Египет, Хургада</div>
                        <div className="text-secondary-300 font-bold">от 94 500 ₸</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppPromo;
